export default {
  tableCategoryOptions: [
    // {
    //   value: null,
    //   name: "All Categories",
    // },
    {
      value: "vision",
      name: "Vision/Binocular/Peds",
    },

    {
      value: "color",
      name: "Color Vision",
    },

    {
      value: "anterior",
      name: "Anterior Seg.",
    },
    {
      value: "dry_eye",
      name: "Dry Eye",
    },
    {
      value: "gonio",
      name: "Gonioscopy/Angles",
    },
    {
      value: "posterior",
      name: "Posterior Seg.",
    },
    {
      value: "neuro",
      name: "Neuro/ONH",
    },
  ],
  ed_imageCategoryOptions: [
    { value: null, name: "All" },
    { value: "vision", name: "Vision" },
    { value: "anterior", name: "Anterior" },
    { value: "glaucoma", name: "Glaucoma" },
    { value: "posterior", name: "Posterior" },
    { value: "neuro", name: "Neuro" },
  ],
};
